import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolderArrowUp32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFolderArrowUp32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.394 8H7a1 1 0 0 0-1 1v1h8.263l-1.037-1.555A1 1 0 0 0 12.394 8M4 9v14a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-9a4 4 0 0 0-4-4h-7.333L14.89 7.336A3 3 0 0 0 12.394 6H7a3 3 0 0 0-3 3m11.596 3H24a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V12zm3.951 7.207a1 1 0 0 1-1.414 0L17 18.074V22a1 1 0 1 1-2 0v-3.903l-1.11 1.11a1 1 0 0 1-1.414-1.414l2.829-2.828.707-.708.707.707 2.828 2.829a1 1 0 0 1 0 1.414"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolderArrowUp32);
